import { useHasCapability } from "component/admin";
import { Banner } from "component/banner";
import { Pad } from "component/basics";
import { ConversationScreen } from "component/screen";
import { CTAButton } from "component/button";
import { UtilityText, Heading, TextField } from "component/text";
import { useState } from "react";
import { AdminConfig } from "structure/admin";
import { useDatastore, useServerCallResult } from "util/datastore";
import { Feature } from "util/stdtypes";

export const AdminUsersImportFeature: Feature<AdminConfig, {}> = {
  name: "Admin Users Import",
  key: "adminusersimport",
  subscreens: {
    adminUsersImport: AdminUsersImportScreen,
  },
  config: {
    quickLinks: [
      {
        label: "!Import and export Admin Users",
        screenKey: "adminUsersImport",
      },
    ],
  },
  capabilities: ["modify-admins"],
};

// FIXME: This function is too large and should be broken up
/* eslint-disable-next-line max-lines-per-function */
export function AdminUsersImportScreen() {
  const datastore = useDatastore();
  const adminUsers = useServerCallResult("users", "exportUsers");
  const [importUsers, setImportUsers] = useState("");
  const hasAccess = useHasCapability("adminusers/modify-admins");
  if (hasAccess === false) {
    return (
      <Banner>
        <UtilityText label="You do not have access to this feature" />
      </Banner>
    );
  }

  return (
    <ConversationScreen pad>
      <Pad />
      <Heading type="large" weight="medium" label="Admin Users Export" />
      <Pad />
      <TextField
        multiline
        testID="exported-users"
        value={JSON.stringify(adminUsers, null, 2)}
        onChange={() => {}}
        placeholder="Exported users"
      />
      <Pad />
      <Heading type="large" weight="medium" label="Admin Users Import" />
      <Pad />
      <TextField
        multiline
        testID="import-users"
        value={importUsers}
        onChange={(value) => {
          setImportUsers(value);
        }}
        placeholder="Users to import"
      />
      <Pad />
      <CTAButton
        label="Import Users"
        onPress={() => {
            console.log("importUsers", importUsers);
          datastore.callServerAsync("users", "importUsers", {
            users: JSON.parse(importUsers),
          });
        }}
      />
      <Pad />
    </ConversationScreen>
  );
}
